import { apiClient } from "./ApiClient";

export default class InsuranceApiClient {

    updateInsurance(quoteUid: string, currentInsurance: any, quoteStep: string) {
        return apiClient.instance.request({
            url: '/quote/update-insurance',
            data: {
                quoteUid,
                currentInsurance,
                quoteStep
            }
        });
    }

    getInsuranceCompanies() {
        return apiClient.instance.request({
            url: '/quote/get-insurance-companies'
        });
    }
}